export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13198.c06a28f1.jpg";